import React, { useState, useRef } from "react";
import * as Yup from "yup";
import {
  Form as BaseForm,
  TextField,
  TextAreaField,
  SelectField,
  SubmitButton,
  CancelPopupButton,
} from "../../ui/FormElement";
import { useClaimContext } from "../../contexts/ClaimContext";

import Members from "./Members";

export default function CreateForm({ closeForm }) {
  let FormSchema = Yup.object().shape({
    member: Yup.string().typeError("Member is required"),
    claimType: Yup.string().required("Claim Type is required"),
    reason: Yup.string().required("Details are required"),
  });

  const { dispatch, state, actions } = useClaimContext();

  let [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState({
    member: null,
    claimType: "Talent Insurance",
    reason: "",
  });

  const selectOptions = [];
  const selectMemberRef = useRef(null);

  const formSendSuccess = () => {
    swal({
      title: "Claim Sent!",
      text: "Our claim's specialist will reach out to you shortly.",
      html: true,
      type: "success",
      showCancelButton: false,
      confirmButtonText: "Close",
      closeOnConfirm: true,
    });
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    actions.addClaim(dispatch, values, () => {
      setLoader(false);
      closeForm();
      formSendSuccess();
      actions.loadClaims(dispatch);
    });
  };

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <Members ref={selectMemberRef} />

      <TextField
        disabled
        name="claimType"
        label={
          <>
            <span>Claim Type</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <TextAreaField
        name="reason"
        label={
          <>
            <span>Details</span>
            <abbr title="required">*</abbr>
          </>
        }
      />

      <div className="text-center mt50 mb30">
        <CancelPopupButton
          className="btn btn-primary btn-outline mr5 ml5 width-120"
          title="Cancel"
          onClick={closeForm}
        />
        <SubmitButton
          title={loader ? "Please, wait ..." : "Send"}
          className={`btn width-120 btn-primary submit-button mr5 ml5 ${
            loader ? "not-possible-click" : ""
          }`}
        />
      </div>
    </BaseForm>
  );
}
